import React from "react";
import type { ReportNoteTabKey } from "../../constants/reportNotes";
import { ReportTabNotesSection } from "./ReportTabNotesSection";

/**
 * Standard report section tab shell: main content, then tab-scoped notes, then prev/next footer.
 */
export function ReportSectionTabLayout(props: {
  reportId: string;
  tabKey: ReportNoteTabKey;
  borderColor: string;
  subtleText: string;
  textColor: string;
  /** Prev/next section navigation (rendered below notes). */
  footer: React.ReactNode;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <>
      {props.children}
      <ReportTabNotesSection
        reportId={props.reportId}
        tabKey={props.tabKey}
        borderColor={props.borderColor}
        subtleText={props.subtleText}
        textColor={props.textColor}
      />
      {props.footer}
    </>
  );
}
